import React, { createContext, useContext } from 'react';
import { useAdminTheme } from '../hooks/useAdminTheme';

const AdminThemeContext = createContext(null);

export function AdminThemeProvider({ children }) {
  const adminTheme = useAdminTheme();
  return (
    <AdminThemeContext.Provider value={adminTheme}>
      {children}
    </AdminThemeContext.Provider>
  );
}

export function useAdminThemeContext() {
  const context = useContext(AdminThemeContext);
  if (!context) {
    throw new Error('useAdminThemeContext must be used within AdminThemeProvider');
  }
  return context;
}
